{
  "accept": "接受",
  "action": "操作",
  "allCountries": "所有国家",
  "allPayments": "所有付款方式",
  "allTypes": "所有类型",
  "amount": "数量",
  "asset": "资产",
  "buy": "买入",
  "buyer": "买家",
  "cancel": "取消",
  "cancelFailed": "订单取消失败。",
  "cancelled": "已取消",
  "completed": "已完成",
  "country": "国家",
  "createP2pAd": "发布 P2P 广告",
  "dispute": "申诉",
  "disputeReason": "申诉原因",
  "escrow": "担保交易",
  "escrowActive": "担保进行中",
  "escrowProtection": "担保保护",
  "escrowReady": "担保就绪",
  "fillAllFields": "请填写所有必填字段。",
  "global": "全球",
  "globalP2pTrading": "全球 P2P 交易",
  "inEscrow": "担保中",
  "inTrade": "交易中",
  "liveGlobalAds": "实时全球广告",
  "loading": "加载中...",
  "markPaid": "标记为已付款",
  "noP2pAdsFound": "未找到 P2P 广告。",
  "offline": "离线",
  "online": "在线",
  "open": "进行中",
  "openDispute": "发起申诉",
  "orderCancelledRefunded": "订单已取消，锁定的资产已退还。",
  "orderDetails": "订单详情",
  "orderId": "订单编号",
  "p2pOrderCreated": "P2P 订单创建成功。",
  "p2pSecurity": "P2P 安全保障",
  "p2pSecurity1": "用户对用户交易",
  "p2pSecurity2": "实时数据库订单",
  "p2pSecurity3": "担保状态追踪",
  "p2pSecurity4": "付款凭证上传",
  "p2pSecurity5": "管理员审核支持",
  "p2pSecurity6": "安全的 P2P 状态流程",
  "p2pSubtitle": "在全球范围内买卖加密货币，享受安全的担保交易保护。",
  "p2pTitle": "全球 P2P 交易",
  "payment": "付款方式",
  "paymentMethod": "付款方式",
  "paymentProof": "付款凭证",
  "paymentSent": "已付款",
  "paymentSubmitted": "付款凭证提交成功。",
  "pleaseLoginFirst": "请先登录。",
  "price": "价格",
  "processing": "处理中...",
  "release": "放行",
  "releaseFailed": "资产放行失败。",
  "selectPaymentMethod": "选择付款方式",
  "sell": "卖出",
  "seller": "卖家",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。",
  "status": "状态",
  "totalOrders": "订单总数",
  "tradeCompletedSuccessfully": "交易已成功完成。",
  "tradeFailed": "交易失败。",
  "tradeStartedSuccessfully": "交易已成功开始。",
  "trader": "交易者",
  "unknownTrader": "交易者",
  "uploadPaymentProof": "请上传付款凭证。",
  "uploadProof": "上传凭证",
  "verifiedMerchant": "认证商家",
  "waitingEscrow": "等待担保",
  "walletAddress": "钱包地址"
}